import React from 'react';

const RadioInput = ({ name, value, options, style }) => (
    <div style={style}>
        {name}:
        {options.map((option) => (
            <label key={option}>
                <input
                    type="radio"
                    name={name}
                    value={option}
                    checked={value === option}
                    onChange={() => {}}
                />
                {option}
            </label>
        ))}
    </div>
);

export default RadioInput;
